// Tooltip.tsx
import React, { useState, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  skip?: boolean;
  paddingTop?: number;
  width?: React.CSSProperties["width"];
}

const Tooltip: React.FC<TooltipProps> = ({
  text,
  children,
  skip = false,
  paddingTop = 8,
  width,
}) => {
  const [position, setPosition] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  });
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [tooltipHight, setTooltipHight] = useState(0);
  const ref = useRef<HTMLDivElement | null>(null);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const updatePosition = () => {
    const rect = tooltipRef.current?.getBoundingClientRect() as DOMRect;
    if (tooltipRef.current) {
      setPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX + rect.width / 2,
      });
    }
  };

  const handleMouseEnter = () => {
    updatePosition();
    setIsTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setIsTooltipVisible(false);
  };

  useLayoutEffect(() => {
    if (ref.current?.offsetHeight) setTooltipHight(ref.current?.offsetHeight);
  }, [ref.current?.offsetHeight]);
  if (skip) {
    return children;
  }
  return (
    <>
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ position: "relative" }}
        ref={tooltipRef}
      >
        {children}
      </div>
      {isTooltipVisible &&
        ReactDOM.createPortal(
          <div
            className="tooltip-container"
            ref={ref}
            style={{
              top: position.top - tooltipHight - paddingTop,
              left: position.left,
              whiteSpace: "pre-wrap",
              width,
            }}
          >
            {text}
          </div>,
          document.body,
        )}
    </>
  );
};

export default Tooltip;
